/**
 * Capitalizes the first letter of the passed string.
 * @param {string} str The string to capitalize.
 * @returns {string} The passed string, with the first character in uppercase.
 */
export const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getAIProviderLabel = (provider?: string): string => {
  switch (provider) {
    case 'openai':
      return 'ChatGPT';
    case 'perplexity':
      return 'Perplexity AI';
    case 'anthropic':
      return 'Claude';
    case 'gemini':
      return 'Gemini';
    default:
      return provider || 'Unknown';
  }
};

export const sentimentScoreToPercentage = (score: number): number =>
  Math.round(((score + 1) / 2) * 100);
